// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "event.proto" (syntax proto3)
// tslint:disable
import { EventService } from "./event";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service EventService
 */
export class EventServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = EventService.typeName;
        this.methods = EventService.methods;
        this.options = EventService.options;
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGet
     */
    batchGet(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update
     */
    update(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ResolveEventTrade
     */
    resolveEventTrade(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSubtypeTrades
     */
    getSubtypeTrades(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCalendarData
     */
    getCalendarData(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: WriteQuote
     */
    writeQuote(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReadQuotes
     */
    readQuotes(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetProjectTasks
     */
    getProjectTasks(input, options) {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLaborHoursByEventID
     */
    getLaborHoursByEventID(input, options) {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetCostReportData
     */
    batchGetCostReportData(input, options) {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateJobAdmin
     */
    createJobAdmin(input, options) {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetJobAdmin
     */
    getJobAdmin(input, options) {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetJobAdmin
     */
    batchGetJobAdmin(input, options) {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateJobAdmin
     */
    updateJobAdmin(input, options) {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteJobAdmin
     */
    deleteJobAdmin(input, options) {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetClosestProperty
     */
    getClosestProperty(input, options) {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GeolocationCheckout
     */
    geolocationCheckout(input, options) {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateEventAssignment
     */
    createEventAssignment(input, options) {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetEventAssignment
     */
    getEventAssignment(input, options) {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetEventAssignment
     */
    batchGetEventAssignment(input, options) {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateEventAssignment
     */
    updateEventAssignment(input, options) {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteEventAssignment
     */
    deleteEventAssignment(input, options) {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateQuickBooksTrackingCode
     */
    createQuickBooksTrackingCode(input, options) {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetQuickBooksTrackingCode
     */
    getQuickBooksTrackingCode(input, options) {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetQuickBooksTrackingCode
     */
    batchGetQuickBooksTrackingCode(input, options) {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateQuickBooksTrackingCode
     */
    updateQuickBooksTrackingCode(input, options) {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteQuickBooksTrackingCode
     */
    deleteQuickBooksTrackingCode(input, options) {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPendingBilling
     */
    getPendingBilling(input, options) {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetPendingBilling
     */
    batchGetPendingBilling(input, options) {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateContract
     */
    createContract(input, options) {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetContract
     */
    getContract(input, options) {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetContract
     */
    batchGetContract(input, options) {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateContract
     */
    updateContract(input, options) {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ApproveContract
     */
    approveContract(input, options) {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * RenewContract closes the current term (allowed within the renewal window of the term end) and
     * creates its successor contract, pending Admin Review. Pricing carries forward verbatim; a
     * live Helcim subscription moves to the successor.
     *
     * @generated from protobuf rpc: RenewContract
     */
    renewContract(input, options) {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * UndoContractRenewal reverses a renewal whose successor term is no longer live: the successor's
     * renewed_from_contract_id is released and, while the predecessor is still active, its memberships
     * stamped renewed go back to active. contract_id is the predecessor. Refused while the successor is
     * still active; a contract with no successor is a no-op.
     *
     * @generated from protobuf rpc: UndoContractRenewal
     */
    undoContractRenewal(input, options) {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CreateContractSubscription starts Helcim autobilling for a contract: the recurring amount
     * is read server-side from the referenced invoice's locked-in total (never client-supplied),
     * the subscription is created against the configured anchor plan, and the contract is
     * stamped with helcim_subscription_id + billing_type helcim_auto.
     *
     * @generated from protobuf rpc: CreateContractSubscription
     */
    createContractSubscription(input, options) {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * CancelContractSubscription soft-cancels the contract's Helcim subscription and flips the
     * contract's billing type to manual. The subscription id stays on the row for audit.
     *
     * @generated from protobuf rpc: CancelContractSubscription
     */
    cancelContractSubscription(input, options) {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * AdoptContractSubscription links a subscription Helcim already started — an online-form
     * signup that paid before Kalos knew about them — onto the contract, stamping
     * helcim_subscription_id + billing_type helcim_auto. Refuses if either the contract or the
     * subscription is already spoken for, if the subscription belongs to another customer, or if
     * Helcim is no longer billing it (cancelled, paused, or ended).
     *
     * @generated from protobuf rpc: AdoptContractSubscription
     */
    adoptContractSubscription(input, options) {
        const method = this.methods[41], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CompleteWelcomeCall
     */
    completeWelcomeCall(input, options) {
        const method = this.methods[42], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteContract
     */
    deleteContract(input, options) {
        const method = this.methods[43], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * PurgeContract is the nuclear delete; the Manage Contract drawer gates it behind
     * MembershipAdmin. Hides every job on the contract or its memberships that is not Completed
     * (isActive = 0), cancels open filter orders on those jobs, deactivates the memberships, stops
     * Helcim autobill, and deactivates the contract. Nothing is hard-deleted; invoices are left as
     * they are. Refuses while any contract invoice is paid.
     *
     * @generated from protobuf rpc: PurgeContract
     */
    purgeContract(input, options) {
        const method = this.methods[44], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * PreviewPurgeContract is the read behind PurgeContract's confirm: what the purge would
     * deactivate, and the paid-invoice count that would make it refuse. Writes nothing.
     *
     * @generated from protobuf rpc: PreviewPurgeContract
     */
    previewPurgeContract(input, options) {
        const method = this.methods[45], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetMaterialsByContractID
     */
    getMaterialsByContractID(input, options) {
        const method = this.methods[46], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateContractFrequency
     */
    createContractFrequency(input, options) {
        const method = this.methods[47], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetContractFrequency
     */
    getContractFrequency(input, options) {
        const method = this.methods[48], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetContractFrequency
     */
    batchGetContractFrequency(input, options) {
        const method = this.methods[49], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateContractFrequency
     */
    updateContractFrequency(input, options) {
        const method = this.methods[50], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteContractFrequency
     */
    deleteContractFrequency(input, options) {
        const method = this.methods[51], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateInvoice
     */
    createInvoice(input, options) {
        const method = this.methods[52], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInvoice
     */
    getInvoice(input, options) {
        const method = this.methods[53], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetInvoice
     */
    batchGetInvoice(input, options) {
        const method = this.methods[54], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateInvoice
     */
    updateInvoice(input, options) {
        const method = this.methods[55], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteInvoice
     */
    deleteInvoice(input, options) {
        const method = this.methods[56], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SendSQSInvoiceEmail
     */
    sendSQSInvoiceEmail(input, options) {
        const method = this.methods[57], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInvoiceBody
     */
    getInvoiceBody(input, options) {
        const method = this.methods[58], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateSiLink
     */
    createSiLink(input, options) {
        const method = this.methods[59], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSiLink
     */
    getSiLink(input, options) {
        const method = this.methods[60], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetSiLink
     */
    batchGetSiLink(input, options) {
        const method = this.methods[61], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSiLink
     */
    updateSiLink(input, options) {
        const method = this.methods[62], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteSiLink
     */
    deleteSiLink(input, options) {
        const method = this.methods[63], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateMaintenanceQuestion
     */
    createMaintenanceQuestion(input, options) {
        const method = this.methods[64], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetMaintenanceQuestion
     */
    getMaintenanceQuestion(input, options) {
        const method = this.methods[65], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetMaintenanceQuestion
     */
    batchGetMaintenanceQuestion(input, options) {
        const method = this.methods[66], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateMaintenanceQuestion
     */
    updateMaintenanceQuestion(input, options) {
        const method = this.methods[67], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteMaintenanceQuestion
     */
    deleteMaintenanceQuestion(input, options) {
        const method = this.methods[68], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreatePayment
     */
    createPayment(input, options) {
        const method = this.methods[69], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPayment
     */
    getPayment(input, options) {
        const method = this.methods[70], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetPayment
     */
    batchGetPayment(input, options) {
        const method = this.methods[71], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdatePayment
     */
    updatePayment(input, options) {
        const method = this.methods[72], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeletePayment
     */
    deletePayment(input, options) {
        const method = this.methods[73], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPaymentsByEventID
     */
    getPaymentsByEventID(input, options) {
        const method = this.methods[74], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPaymentsByInvoiceID
     */
    getPaymentsByInvoiceID(input, options) {
        const method = this.methods[75], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateServicesRendered
     */
    createServicesRendered(input, options) {
        const method = this.methods[76], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetServicesRendered
     */
    getServicesRendered(input, options) {
        const method = this.methods[77], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetServicesRendered
     */
    batchGetServicesRendered(input, options) {
        const method = this.methods[78], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateServicesRendered
     */
    updateServicesRendered(input, options) {
        const method = this.methods[79], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteServicesRendered
     */
    deleteServicesRendered(input, options) {
        const method = this.methods[80], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetMostRecentServicesRenderedByEventIDs
     */
    getMostRecentServicesRenderedByEventIDs(input, options) {
        const method = this.methods[81], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetEventDetails
     */
    getEventDetails(input, options) {
        const method = this.methods[82], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GeolocationCheckoutReturnTimesheets
     */
    geolocationCheckoutReturnTimesheets(input, options) {
        const method = this.methods[83], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GenerateStripePaymentLink
     */
    generateStripePaymentLink(input, options) {
        const method = this.methods[84], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetPurchaseOrder
     */
    batchGetPurchaseOrder(input, options) {
        const method = this.methods[85], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPurchaseOrder
     */
    getPurchaseOrder(input, options) {
        const method = this.methods[86], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreatePurchaseOrder
     */
    createPurchaseOrder(input, options) {
        const method = this.methods[87], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdatePurchaseOrder
     */
    updatePurchaseOrder(input, options) {
        const method = this.methods[88], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeletePurchaseOrder
     */
    deletePurchaseOrder(input, options) {
        const method = this.methods[89], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetPurchaseOrderRequisitionItem
     */
    batchGetPurchaseOrderRequisitionItem(input, options) {
        const method = this.methods[90], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPurchaseOrderRequisitionItem
     */
    getPurchaseOrderRequisitionItem(input, options) {
        const method = this.methods[91], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreatePurchaseOrderRequisitionItem
     */
    createPurchaseOrderRequisitionItem(input, options) {
        const method = this.methods[92], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdatePurchaseOrderRequisitionItem
     */
    updatePurchaseOrderRequisitionItem(input, options) {
        const method = this.methods[93], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeletePurchaseOrderRequisitionItem
     */
    deletePurchaseOrderRequisitionItem(input, options) {
        const method = this.methods[94], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: FetchUpcomingSubAccountEvents
     */
    fetchUpcomingSubAccountEvents(input, options) {
        const method = this.methods[95], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: FetchSubAccountEventHistory
     */
    fetchSubAccountEventHistory(input, options) {
        const method = this.methods[96], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MostLikelyJob
     */
    mostLikelyJob(input, options) {
        const method = this.methods[97], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetProjectEvent
     */
    getProjectEvent(input, options) {
        const method = this.methods[98], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetProjectEvent
     */
    batchGetProjectEvent(input, options) {
        const method = this.methods[99], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateProjectEvent
     */
    createProjectEvent(input, options) {
        const method = this.methods[100], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateProjectEvent
     */
    updateProjectEvent(input, options) {
        const method = this.methods[101], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteProjectEvent
     */
    deleteProjectEvent(input, options) {
        const method = this.methods[102], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInvoicePayment
     */
    getInvoicePayment(input, options) {
        const method = this.methods[103], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetInvoicePayment
     */
    batchGetInvoicePayment(input, options) {
        const method = this.methods[104], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateInvoicePayment
     */
    createInvoicePayment(input, options) {
        const method = this.methods[105], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateInvoicePayment
     */
    updateInvoicePayment(input, options) {
        const method = this.methods[106], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteInvoicePayment
     */
    deleteInvoicePayment(input, options) {
        const method = this.methods[107], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInvoicePaymentLine
     */
    getInvoicePaymentLine(input, options) {
        const method = this.methods[108], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetInvoicePaymentLine
     */
    batchGetInvoicePaymentLine(input, options) {
        const method = this.methods[109], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateInvoicePaymentLine
     */
    createInvoicePaymentLine(input, options) {
        const method = this.methods[110], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateInvoicePaymentLine
     */
    updateInvoicePaymentLine(input, options) {
        const method = this.methods[111], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteInvoicePaymentLine
     */
    deleteInvoicePaymentLine(input, options) {
        const method = this.methods[112], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCallCountForTimeRange
     */
    getCallCountForTimeRange(input, options) {
        const method = this.methods[113], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SendInvoiceDocumentLinkWithStripe
     */
    sendInvoiceDocumentLinkWithStripe(input, options) {
        const method = this.methods[114], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchUserByPhone
     */
    searchUserByPhone(input, options) {
        const method = this.methods[115], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPaymentType
     */
    getPaymentType(input, options) {
        const method = this.methods[116], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetPaymentType
     */
    batchGetPaymentType(input, options) {
        const method = this.methods[117], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetServicesRenderedPaymentType
     */
    getServicesRenderedPaymentType(input, options) {
        const method = this.methods[118], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetServicesRenderedPaymentType
     */
    batchGetServicesRenderedPaymentType(input, options) {
        const method = this.methods[119], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: FetchProjectCostAndEstimate
     */
    fetchProjectCostAndEstimate(input, options) {
        const method = this.methods[120], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetEventFeed
     */
    getEventFeed(input, options) {
        const method = this.methods[121], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * PM Schedule tab: paged queue of PM jobs across all contracts, with
     * last-PM/next-due, CSR, and last-activity enrichment done server-side.
     *
     * @generated from protobuf rpc: BatchGetPmQueue
     */
    batchGetPmQueue(input, options) {
        const method = this.methods[122], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: PreviewInvoice
     */
    previewInvoice(input, options) {
        const method = this.methods[123], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SendPendingInvoice
     */
    sendPendingInvoice(input, options) {
        const method = this.methods[124], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SendPaidInvoice
     */
    sendPaidInvoice(input, options) {
        const method = this.methods[125], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInvoiceDownloadLink
     */
    getInvoiceDownloadLink(input, options) {
        const method = this.methods[126], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Project Invoice RPCs
     * Deprecated: Use PreviewInvoice instead which now handles both regular and project invoices
     *
     * @deprecated
     * @generated from protobuf rpc: PreviewProjectInvoice
     */
    previewProjectInvoice(input, options) {
        const method = this.methods[127], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deprecated: Use SendPendingInvoice instead which now handles both regular and project invoices
     *
     * @deprecated
     * @generated from protobuf rpc: SendPendingProjectInvoice
     */
    sendPendingProjectInvoice(input, options) {
        const method = this.methods[128], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deprecated: Use SendPaidInvoice instead which now handles both regular and project invoices
     *
     * @deprecated
     * @generated from protobuf rpc: SendPaidProjectInvoice
     */
    sendPaidProjectInvoice(input, options) {
        const method = this.methods[129], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreatePaymentIntent
     */
    createPaymentIntent(input, options) {
        const method = this.methods[130], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetStripePublishableKey
     */
    getStripePublishableKey(input, options) {
        const method = this.methods[131], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * New invoice payment functions
     *
     * @generated from protobuf rpc: CreateInvoicePaymentToken
     */
    createInvoicePaymentToken(input, options) {
        const method = this.methods[132], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateInvoicePaymentLink
     */
    createInvoicePaymentLink(input, options) {
        const method = this.methods[133], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPublicInvoicePaymentData
     */
    getPublicInvoicePaymentData(input, options) {
        const method = this.methods[134], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CalculateInvoiceTotal
     */
    calculateInvoiceTotal(input, options) {
        const method = this.methods[135], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deprecated: Use CalculateInvoiceTotal instead which now handles both regular and project invoices
     *
     * @deprecated
     * @generated from protobuf rpc: CalculateProjectInvoiceTotal
     */
    calculateProjectInvoiceTotal(input, options) {
        const method = this.methods[136], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Multi-invoice payment system
     *
     * @generated from protobuf rpc: RecordInvoicePaymentV2
     */
    recordInvoicePaymentV2(input, options) {
        const method = this.methods[137], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CalculateInvoiceBalance
     */
    calculateInvoiceBalance(input, options) {
        const method = this.methods[138], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInvoicePaymentHistory
     */
    getInvoicePaymentHistory(input, options) {
        const method = this.methods[139], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Unified Job/Project Search API - Handles all search contexts
     * Supports: project searches, department-scoped searches, service calls
     * Job numbers may include year prefix (25-123456) and optional dept suffix (25-123456-PLB)
     *
     * @generated from protobuf rpc: SearchJobs
     */
    searchJobs(input, options) {
        const method = this.methods[140], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Unified Job/Project Search V2 - Same semantics as SearchJobs but uses an optimized
     * view that aggregates sub-job data via GROUP_CONCAT, eliminating the double-scan pattern.
     * One row per project/service call, sub-job fields searchable via aggregated CSV columns.
     *
     * @generated from protobuf rpc: SearchJobsV2
     */
    searchJobsV2(input, options) {
        const method = this.methods[141], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Call Window Event Search - Fuzzy search for CS to find jobs by any customer/property/job info
     * Searches across: name, phone, email, address, job number
     * Returns events with full customer and property context for rescheduling workflow
     *
     * @generated from protobuf rpc: SearchEventsCallWindow
     */
    searchEventsCallWindow(input, options) {
        const method = this.methods[142], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Validate Job Number - Used by search widgets to validate job numbers
     * Returns project context and all associated jobs if valid
     * Automatically filters for active, non-archived jobs with valid property_id
     *
     * @generated from protobuf rpc: ValidateJobNumber
     */
    validateJobNumber(input, options) {
        const method = this.methods[143], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetReminders
     */
    batchGetReminders(input, options) {
        const method = this.methods[144], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * BulkCreateWindowBlocks creates window-block records for every combination
     * of department × job-type × date × call-window in a single server-side
     * transaction, skipping any slot that is already blocked.
     *
     * @generated from protobuf rpc: BulkCreateWindowBlocks
     */
    bulkCreateWindowBlocks(input, options) {
        const method = this.methods[145], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateEventPhoto
     */
    createEventPhoto(input, options) {
        const method = this.methods[146], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetEventPhoto
     */
    getEventPhoto(input, options) {
        const method = this.methods[147], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetEventPhoto
     */
    batchGetEventPhoto(input, options) {
        const method = this.methods[148], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateEventPhoto
     */
    updateEventPhoto(input, options) {
        const method = this.methods[149], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteEventPhoto
     */
    deleteEventPhoto(input, options) {
        const method = this.methods[150], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetCommercialServiceQueue
     */
    batchGetCommercialServiceQueue(input, options) {
        const method = this.methods[151], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetCommercialServiceQueueLocation
     */
    batchGetCommercialServiceQueueLocation(input, options) {
        const method = this.methods[152], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
